import React from "react";
import AddNewBuilding from "../features/AddNewBuilding";
import { LicenseAppType, OrganisationOUT } from "api-client";
import AssetDashboards from "./AssetDashboards";
import BuildingsList from "./BuildingsList";
import LCADashboards from "./LCADashboards";
import CountOfBuildings from "./CountOfBuildings";
import { OrganisationBuildings } from "../SidebarMenuStore";
import OrganisationNoLicense from "./OrganisationNoLicense";
import ManufacturerDashboards from "./ManufacturerDashboards";

interface OrganisationContentProps {
  isAsset: boolean;
  organisation?: OrganisationOUT;
  buildings: OrganisationBuildings;
  licenseType?: LicenseAppType | null;
}

const OrganisationContent = (props: OrganisationContentProps) => {
  if (!props.organisation) return null;

  if (!props.organisation.license)
    return <OrganisationNoLicense organisationID={props.organisation.id} />;

  function buildingsCount() {
    return (
      <div className="mx-4 border-t border-gray-200 flex justify-center items-center mt-2 -mb-2 pb-4">
        <CountOfBuildings
          buildingsCount={props.buildings.count}
          className="px-5 -mt-[9px] bg-white"
        />
      </div>
    );
  }

  if (!props.organisation) return null;

  return (
    <>
      {props.licenseType == LicenseAppType.Manufacturer && (
        <ManufacturerDashboards organisation={props.organisation} />
      )}
      {props.licenseType == LicenseAppType.Asset && (
        <AssetDashboards organisation={props.organisation} />
      )}
      {props.licenseType == LicenseAppType.Lca && (
        <>
          <LCADashboards organisation={props.organisation} />
          {buildingsCount()}
          <BuildingsList
            buildings={props.buildings.items}
            loading={props.buildings.loading}
          />
        </>
      )}
      {props.licenseType == LicenseAppType.Lca && (
        <AddNewBuilding organisation={props.organisation} />
      )}
    </>
  );
};

export default OrganisationContent;
